import {
  constants,
  typographyStyles,
  mediaQueryStyles,
} from "@newsela/angelou";

import { dangerRedWithOpacity } from "@/angelouCE/utils/constants";

const { mediaQuery } = mediaQueryStyles;
const {
  BreakpointNames: { xs, md },
} = constants.breakpoints;

const { colors } = constants;
const { ui } = colors;
const red = colors.status.danger[600];

const { heading6Obj } = typographyStyles;

export const activityErrorMessageContainerCss = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-end",
  alignItems: "center",
  height: "50%",
  width: "100%",
  [mediaQuery.upTo(md)]: {
    height: "48%",
  },
  [mediaQuery.upTo(xs)]: {
    height: "30%",
  },
};

export const activityErrorMessageCss = {
  ...heading6Obj,
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  height: "56px",
  width: "100%",
  padding: "16px 16px",
  borderRadius: "8px",
  backgroundColor: dangerRedWithOpacity,
  color: ui.red[600],
};

export const messageContainerCss = {
  textAlign: "center",
};

export const iconCss = {
  width: "24px",
  height: "24px",
  marginRight: "8px",
  path: {
    fill: red,

    "&:first-of-type": {
      stroke: red,
    },
  },
};
